export const isDigitsOnly = (value: string | undefined): boolean => {
  if (value === undefined || value === '') {
    return true;
  }
  if (typeof value !== 'undefined') {
    return /^\d+$/.test(value);
  }
  return false;
};
